import { render, staticRenderFns } from "./CategorySortRowActions.vue?vue&type=template&id=3ae6b07c&"
import script from "./CategorySortRowActions.vue?vue&type=script&lang=js&"
export * from "./CategorySortRowActions.vue?vue&type=script&lang=js&"
import style0 from "./CategorySortRowActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {LoadingOverlay: require('/lasso/components/LoadingOverlay.vue').default,Template: require('/lasso/components/templates/Template.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae6b07c')) {
      api.createRecord('3ae6b07c', component.options)
    } else {
      api.reload('3ae6b07c', component.options)
    }
    module.hot.accept("./CategorySortRowActions.vue?vue&type=template&id=3ae6b07c&", function () {
      api.rerender('3ae6b07c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/CategorySortRowActions.vue"
export default component.exports